import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getQueryConversation, UserQuery } from './UserQueries.api';

/** Page URL that opens one ticket's conversation, e.g. /my-queries?ticket=concern-338. */
export const ticketLink = (admin: boolean, source: string, id: number) =>
  `${admin ? '/admin/user-queries' : '/my-queries'}?ticket=${source}-${id}`;

/*
 * Opens the ticket named by ?ticket= (set by a support notification). The ticket is fetched by
 * ID, so it opens even when it is not on the list page currently shown. Returns `clear`, which
 * the page calls when its conversation closes so the same notification can be opened again.
 */
export function useLinkedTicket(admin: boolean, enabled: boolean, open: (ticket: UserQuery) => void, onError: (message: string) => void) {
  const [params, setParams] = useSearchParams();
  const value = params.get('ticket');
  const callbacks = useRef({ open, onError });
  callbacks.current = { open, onError };
  const clear = () => {
    if (!params.has('ticket')) return;
    const next = new URLSearchParams(params);
    next.delete('ticket');
    setParams(next, { replace: true });
  };
  useEffect(() => {
    if (!enabled || !value) return;
    const match = /^(concern|feedback)-(\d+)$/.exec(value);
    if (!match) return;
    let active = true;
    getQueryConversation({ source: match[1], id: Number(match[2]) } as UserQuery, admin)
      .then(ticket => { if (active) callbacks.current.open(ticket); })
      .catch(() => { if (active) callbacks.current.onError('We couldn’t open that conversation. It may no longer be available.'); });
    return () => { active = false; };
  }, [admin, enabled, value]);
  return clear;
}
